var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { createContext, useContext, useCallback, useReducer } from "react";

var useReducerContext = function (_a) {
  var _b = _a.initState,
      initState = _b === void 0 ? {} : _b;
  var Context = createContext({
    state: initState,
    dispatch: function () {}
  });

  var Provider = function (_a) {
    var children = _a.children;
    var reducer = useCallback(function (preState, action) {
      var type = action.type,
          payload = action.payload;

      switch (type) {
        default:
          return preState;

        case "upgrade":
          return __assign(__assign({}, preState), payload);
      }
    }, []);

    var _b = useReducer(reducer, initState),
        state = _b[0],
        dispatch = _b[1];

    return React.createElement(Context.Provider, {
      value: {
        state: state,
        dispatch: dispatch
      }
    }, children);
  };

  var Contexts = function () {
    return useContext(Context);
  };

  return [Provider, Contexts];
};

export { useReducerContext };